import React, { useEffect, useRef } from "react";
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { failureAlert, successAlert2, successAlertRefresh } from "../../CommonUtils/SweetAlerts";
import Swal from "sweetalert2";
import * as bie from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { BsEyeFill } from "react-icons/bs";
import { viewImage } from "../../CommonUtils/viewImage";
import * as Yup from "yup";
import allowNumbersOnly, { AllowFloats, handlePaste } from "../../CommonUtils/CommonValidations";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { useState } from "react";
import { config } from "../../CommonUtils/CommonURLS";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";

export default function BuildBlockdtls({ goNext, paymentDone }) {
  const [blockdata, setBlockdata] = useState([]);
  const hasFetchedData = useRef(false);
  const [BuildingReport, SetBuildingReport] = useState([]);

  const [Collegetype, SetCollegeType] = useState("");

  const dispatch = useDispatch();
  const validationSchema = Yup.object({
    // ===== Main Fields =====
    instructionalArea: Yup.string().required(ERROR_MSG),
    adminArea: Yup.string().required(ERROR_MSG),
    amenitiesArea: Yup.string().required(ERROR_MSG),
    accessCirculArea: Yup.string().required(ERROR_MSG),

    // ===== Building Blocks Array =====
    buildingblocks: Yup.array().of(
      Yup.object().shape({
        blockNo: Yup.string().required(ERROR_MSG),
        buildBlockName: Yup.string().required(ERROR_MSG),
        noOfFloors: Yup.string().required(ERROR_MSG),
        // if siteArea is array
        siteArea: Yup.array()
          .of(
            Yup.string()
              .required("Built-up Area is required")
              .test("is-valid-number", "Enter valid area", (value) => value && !isNaN(value) && Number(value) > 0),
          )
          .min(1, "Enter Built-up Area"),

        campusType: Yup.string().required(ERROR_MSG),

        // image validation (if required)
        buildingImg: Yup.string().required("Please upload building image"),
      }),
    ),
  });

  const BldformIk = useFormik({
    initialValues: {
      instructionalArea: "",
      adminArea: "",
      amenitiesArea: "",
      accessCirculArea: "",
      buildingblocks: [
        {
          buildBlockName: "",
          blockNo: "",
          noOfFloors: "",
          siteArea: [],
          campusType: "",
          buildingImg: "",
        },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submitDetails(values);
    },
  });

  function submitDetails(values) {
    const bb = values.buildingblocks;
    if (Array.isArray(bb) && bb.length > 0) {
      const incomplete = bb.some((block, idx) => {
        const { buildBlockName, blockNo, noOfFloors, siteArea, campusType, buildingImg } = block;

        // 1. Determine if *any* field has been started
        const anyStarted = [buildBlockName, blockNo, noOfFloors, campusType, buildingImg].some((v) => typeof v === "string" && v.trim() !== "") || (Array.isArray(siteArea) && siteArea.length > 0);

        if (!anyStarted) {
          // Entire row blank → OK
          return false;
        }

        // 2. Validate that *all* required fields are non-empty
        const missingRequired =
          typeof buildBlockName !== "string" ||
          buildBlockName.trim() === "" ||
          typeof blockNo !== "string" ||
          blockNo.trim() === "" ||
          typeof noOfFloors !== "string" ||
          noOfFloors.trim() === "" ||
          !Array.isArray(siteArea) ||
          siteArea.length === 0 ||
          typeof campusType !== "string" ||
          campusType.trim() === "" ||
          typeof buildingImg !== "string" ||
          buildingImg.trim() === "";

        return missingRequired;
      });

      if (incomplete) {
        InfoAlert("Please fill out all fields in each building block.");
      } else {
        if (Array.isArray(values.buildingblocks)) {
          values.buildingblocks = values.buildingblocks.filter((block) => {
            // If buildBlockName is missing or blank, drop this block
            return typeof block.buildBlockName === "string" && block.buildBlockName.trim() !== "";
          });
        }

        let valid = true;
        values.buildingblocks.forEach((block, blockIndex) => {
          const noOfFloors = parseInt(values.buildingblocks[blockIndex]?.noOfFloors) || 0;
          const siteAreaLength = block.siteArea.length;
          if (siteAreaLength !== noOfFloors) {
            valid = false;
            console.log(`For block ${blockIndex + 1}, the number of siteArea fields doesn't match the number of floors.`);
          }
          block.siteArea.forEach((area, index) => {
            if (!area || isNaN(area) || parseFloat(area) <= 0) {
              valid = false;
              console.log(`Invalid siteArea for floor ${index + 1} in block ${blockIndex + 1}`);
            }
          });
        });
        if (!valid) {
          Swal.fire({
            text: "Please ensure all Built-up Area fields are filled correctly.",
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }

        values.buildingblocks.forEach((block) => {
          block.siteArea = block.siteArea.map((area) => parseInt(area, 10));
        });

        values.totalArea = parseInt(values.totalArea, 10);

        Swal.fire({
          text: "Are you sure you want to submit?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, submit it!",
          cancelButtonText: "No, cancel!",
          backdrop: false,
        }).then((result) => {
          if (result.isConfirmed) {
            let url = config.url.FAC_URL + "afflbuildingblocks";
            CommonAxiosPost(url, values, dispatch)
              .then((res) => {
                if (res?.data?.status === true) {
                  successAlert2(res?.data?.sdesc);
                  Getdata();
                  goNext();
                } else {
                  failureAlert(res?.data?.sdesc);
                }
              })
              .catch((err) => {});
          }
        });
      }
    }
  }

  const GetCollegeType = () => {
    const url = `${config.url.FAC_URL}clgType`;
    CommonAxiosGet(url).then((res) => {
      if (res !== undefined) {
        console.log("college type", res?.data);
        SetCollegeType(res?.data);
      }
    });
  };

  function Getdata() {
    let url = config.url.FAC_URL + `getbuildingblocks`;
    CommonAxiosGet(url, dispatch).then((res) => {
      if (res?.data?.scode === "01") {
        setBlockdata(res?.data?.building);
      } else {
        setBlockdata([]);
      }
    });
  }
  function BuildingBlockReport() {
    let url = config.url.FAC_URL + `getbldareadtls`;
    CommonAxiosGet(url, dispatch).then((res) => {
      if (res?.data?.scode == "01") {
        SetBuildingReport(res?.data?.buildingarea);
        BldformIk.setFieldValue("amenitiesArea", res?.data?.buildingarea[0]?.amenities_area);
        BldformIk.setFieldValue("adminArea", res?.data?.buildingarea[0]?.admin_area);
        BldformIk.setFieldValue("instructionalArea", res?.data?.buildingarea[0]?.instructional_area);
        BldformIk.setFieldValue("accessCirculArea", res?.data?.buildingarea[0]?.access_circul_area);
        BldformIk.setFieldValue("totalArea", res?.data?.buildingarea[0]?.total_area);
      } else {
        SetBuildingReport({
          buildingblocks: [
            {
              buildBlockName: "",
              blockNo: "",
              noOfFloors: "",
              siteArea: [],
              campusType: "",
              buildingImg: "",
            },
          ],
        });
      }
    });
  }

  function sum() {
    const instructionalArea = parseFloat(BldformIk?.values?.instructionalArea) || 0;
    const adminArea = parseFloat(BldformIk?.values?.adminArea) || 0;
    const amenitiesArea = parseFloat(BldformIk?.values?.amenitiesArea) || 0;
    const accessCirculArea = parseFloat(BldformIk?.values?.accessCirculArea) || 0;
    const total = instructionalArea + adminArea + amenitiesArea + accessCirculArea;
    BldformIk?.setFieldValue("totalArea", total.toFixed(2));
  }

  function DeleteBuildingReport(sl_no) {
    Swal.fire({
      title: "Are you sure want to Delete ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          slno: sl_no,
        };
        let url = config.url.FAC_URL + `deleteBuildingdtls`;
        CommonAxiosPost(url, payload, dispatch).then((res) => {
          if (res?.data?.scode === "01") {
            Swal.fire("Deleted Successfully", "", "success").then((refresh) => {
              if (refresh.isConfirmed) {
                Getdata();
              }
            });
          } else {
            failureAlert("Something went wrong,Please check");
          }
        });
      }
    });
  }

  useEffect(() => {
    if (!hasFetchedData.current) {
      Getdata();
      BuildingBlockReport();
      GetCollegeType();
      hasFetchedData.current = true;
    }
  }, []);

  return (
    <>
      <div className="faculty-form-wrapper">
        <div className="faculty-card">
          <FormikProvider value={BldformIk}>
            <Form onChange={BldformIk?.handleChange} onSubmit={BldformIk?.handleSubmit} className="affl-form">
              <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                {/* <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1>Building Area Details
                                        ({Collegetype})
                                    </h1>
                                </div> */}

                <h5 className="mb-3 innerheader-new">
                  <span>Building Area Details</span>
                </h5>

                {/* <bie.Row className="my-3 px-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2}>
                                        <bie.InputGroup >
                                            <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Institutional Area</label>
                                            <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="instructionalArea" onPaste={(e) => handlePaste(e)}
                                                className="form-control" onKeyUp={() => { sum(); }} style={{ width: "100px", Height: "100px" }} />
                                            <ErrorMessage name="instructionalArea" component="div" className="text-danger" />
                                        </bie.InputGroup>
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className='mb-2'>
                                        <bie.InputGroup>
                                            <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Administrative Area</label>
                                            <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="adminArea" className="form-control" onKeyUp={() => { sum(); }}
                                                onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="adminArea" component="div" className="text-danger" />
                                        </bie.InputGroup>
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className='mb-3'>
                                        <bie.InputGroup >
                                            <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Amenities Area</label>
                                            <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="amenitiesArea" className="form-control"
                                                onKeyUp={() => { sum(); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="amenitiesArea" component="div" className="text-danger" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className='mb-3' >
                                        <bie.InputGroup>
                                            <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Access & Circulation Area</label>
                                            <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="accessCirculArea" className="form-control" onKeyUp={() => { sum(); }}
                                                onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="accessCirculArea" component="div" className="text-danger" />
                                        </bie.InputGroup>
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className="mb-3">
                                        <bie.InputGroup>
                                            <label className="label-text-style mb-1">Total Built-up Area</label>
                                            <Field type="text" name="totalArea" className="form-control" disabled />
                                            <ErrorMessage name="totalArea" component="div" className="text-danger" />
                                        </bie.InputGroup>
                                    </bie.Col>


                                </bie.Row> */}

                <bie.Row className="mb-3">
                  <bie.Col lg={3}>
                    <label>Institutional Area ({Collegetype})</label>
                    <Field name="instructionalArea" className="form-control" onKeyPress={AllowFloats} onKeyUp={sum} onPaste={handlePaste} />
                    <ErrorMessage name="instructionalArea" component="div" className="text-danger extra-small mt-1" />
                  </bie.Col>

                  <bie.Col lg={3}>
                    <label>Administrative Area ({Collegetype})</label>
                    <Field name="adminArea" className="form-control" onKeyPress={AllowFloats} onKeyUp={sum} onPaste={handlePaste} />
                    <ErrorMessage name="adminArea" component="div" className="text-danger extra-small mt-1" />
                  </bie.Col>

                  <bie.Col lg={3}>
                    <label>Amenities Area ({Collegetype})</label>
                    <Field name="amenitiesArea" className="form-control" onKeyPress={AllowFloats} onKeyUp={sum} onPaste={handlePaste} />
                    <ErrorMessage name="amenitiesArea" component="div" className="text-danger extra-small mt-1" />
                  </bie.Col>

                  <bie.Col lg={3} className="mt-3">
                    <label>Access & Circulation Area ({Collegetype})</label>
                    <Field name="accessCirculArea" className="form-control" onKeyPress={AllowFloats} onKeyUp={sum} onPaste={handlePaste} />
                    <ErrorMessage name="accessCirculArea" component="div" className="text-danger extra-small mt-1" />
                  </bie.Col>

                  <bie.Col lg={3} className="mt-3">
                    <label>Total Built-up Area ({Collegetype})</label>
                    <Field name="totalArea" className="form-control" disabled />
                    <ErrorMessage name="totalArea" component="div" className="text-danger extra-small mt-1" />
                  </bie.Col>
                </bie.Row>

                {/* <div className="inner-herbpage-service-title-sub pt-0"  >
                                    <h1 className="">Building Block Details
                                        ({Collegetype})
                                    </h1>
                                </div> */}

                <h5 className="mb-3 innerheader-new">
                  <span>Building Block Details</span>
                </h5>

                {/* <bie.Alert variant="danger" className='affl-alert'>
                  <p className='mb-0'> <strong>Note:</strong> Survey No. will be populated from Society Land Allotment Details</p>
                </bie.Alert> */}
                <bie.Row className="px-2 my-3 ">
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered mt-2 ">
                      <thead className="table-primary">
                        <tr>
                          <th>
                            {" "}
                            <label className="red-number">*</label>S.No{" "}
                          </th>
                          <th>
                            {" "}
                            <label className="red-number">*</label>Block Number
                          </th>
                          <th>
                            {" "}
                            <label className="red-number">*</label>Building / Block Name
                          </th>
                          <th>
                            {" "}
                            <label className="red-number">*</label>No. of Floors
                          </th>
                          <th>
                            {" "}
                            <label className="red-number">*</label>Built-up Area ({Collegetype})
                          </th>
                          <th>
                            {" "}
                            <label className="red-number">*</label>Upload Building Block Image
                          </th>
                          <th>
                            {" "}
                            <label className="red-number">*</label>Campus Type
                          </th>
                          <th> Action</th>
                        </tr>
                      </thead>
                      <tbody style={{ textAlign: "center" }}>
                        <FieldArray name="buildingblocks">
                          {(Buildingvalues) => {
                            return Buildingvalues?.form?.values?.buildingblocks?.map((qual, index) => {
                              return (
                                <>
                                  <tr>
                                    <td>
                                      <center>{index + 1}</center>
                                    </td>

                                    <td>
                                      <Field
                                        onKeyPress={(e) => {
                                          allowNumbersOnly(e);
                                        }}
                                        maxLength="3"
                                        onPaste={(e) => {
                                          handlePaste(e);
                                        }}
                                        type="text"
                                        className="form-control"
                                        name={`buildingblocks[${index}].blockNo`}
                                      />
                                      <ErrorMessage name={`buildingblocks[${index}].blockNo`} component="div" className="text-danger" />
                                    </td>
                                    <td>
                                      <Field
                                        onKeyPress={(e) => {
                                          allowAlphabetAndSpacesOnly(e);
                                        }}
                                        type="text"
                                        className="form-control"
                                        maxLength="30"
                                        name={`buildingblocks[${index}].buildBlockName`}
                                      />
                                      <ErrorMessage name={`buildingblocks[${index}].buildBlockName`} component="div" className="text-danger" />
                                    </td>
                                    <td className="position-relative">
                                      <Field
                                        component="select"
                                        className="form-control"
                                        name={`buildingblocks[${index}].noOfFloors`}
                                        // onChange={(e) => {
                                        //   Buildingvalues.form.setFieldValue(`buildingblocks[${index}].noOfFloors`, e.target.value);
                                        // }}
                                        onChange={(e) => {
                                          const floors = e.target.value;

                                          Buildingvalues.form.setFieldValue(`buildingblocks[${index}].noOfFloors`, floors);

                                          // Reset siteArea array
                                          Buildingvalues.form.setFieldValue(
                                            `buildingblocks[${index}].siteArea`,
                                            Array.from({ length: floors }, () => ""),
                                          );
                                        }}
                                      >
                                        <option value="">--select--</option>
                                        {[...Array(10).keys()].map((i) => (
                                          <option key={i} value={i + 1}>
                                            {i + 1}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage name={`buildingblocks[${index}].noOfFloors`} component="div" className="text-danger" />
                                    </td>
                                    <td>
                                      {Array.from({ length: parseInt(Buildingvalues?.form?.values?.buildingblocks[index]?.noOfFloors) || 0 }, (_, floorIndex) => (
                                        <div key={floorIndex} className="mb-2">
                                          <Field
                                            onKeyPress={(e) => AllowFloats(e)}
                                            onPaste={(e) => handlePaste(e)}
                                            type="text"
                                            className="form-control"
                                            name={`buildingblocks[${index}].siteArea[${floorIndex}]`}
                                            placeholder={`Built-up Area for Floor ${floorIndex + 1}`}
                                          />
                                          <ErrorMessage name={`buildingblocks[${index}].siteArea[${floorIndex}]`} component="div" className="text-danger" />
                                        </div>
                                      ))}
                                    </td>

                                    <td>
                                      <bie.InputGroup>
                                        <input
                                          type="file"
                                          className="form-control"
                                          name={`buildingblocks[${index}].buildingImg`}
                                          accept="image/*"
                                          onChange={(e) => {
                                            let filename = `buildingImg`;
                                            let path = "/Uploads/BuildingImg/2024/";
                                            ImagePdfBucket(e, BldformIk, path, `buildingblocks[${index}].buildingImg`, filename, "image");
                                          }}
                                        />
                                      </bie.InputGroup>

                                      <Field type="hidden" name={`buildingblocks[${index}].buildingImg`} />

                                      <ErrorMessage name={`buildingblocks[${index}].buildingImg`} component="div" className="text-danger mt-1" style={{ fontSize: "12px" }} />
                                    </td>
                                    <td className="position-relative">
                                      <Field component="select" className="form-control " name={`buildingblocks[${index}].campusType`}>
                                        <option value="">--select--</option>
                                        <option value="off">Off Campus</option>
                                        <option value="main">Main Campus</option>
                                      </Field>
                                      <ErrorMessage name={`buildingblocks[${index}].campusType`} component="div" className="text-danger" />
                                    </td>
                                    <td align="center">
                                      {index === 0 ? (
                                        <>
                                          <button
                                            type="button"
                                            className="button-titile btn btn-sm btn-success"
                                            onClick={() => {
                                              Buildingvalues.push({
                                                blockNo: "",
                                                buildBlockName: "",
                                                noOfFloors: "",
                                                siteArea: [],
                                                upload_buildingimage: "",
                                                buildingImg: "",
                                                campusType: "",
                                              });
                                            }}
                                          >
                                            <VscDiffAdded></VscDiffAdded>{" "}
                                          </button>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {/* {index !== 0 && index === BldformIk?.values?.buildingblocks?.length - 1 ? ( */}

                                      {index > 0 && BldformIk?.values?.buildingblocks?.length > 1 ? (
                                        <>
                                          <button
                                            type="button"
                                            className="button-titile btn btn-sm btn-danger"
                                            onClick={() => {
                                              Buildingvalues?.remove(index);
                                            }}
                                          >
                                            <BiTrash></BiTrash>
                                          </button>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                </>
                              );
                            });
                          }}
                        </FieldArray>
                      </tbody>
                    </table>
                  <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                {paymentDone ? (
                  <div style={{ color: "green", fontWeight: "bold" }}>✅ Already submitted</div>
                ) : (
                  <button type="submit" className="btn btn-success btn-sm mt-2 float-end">
                    Submit
                  </button>
                )}
              </div>
                  </div>

                  {blockdata && blockdata?.length > 0 && (
                    <bie.Row className="px-2 my-3">
                      <div className="table-responsive px-0">
                        <table table className="table table-bordered mt-2 ">
                          <thead className="table-primary">
                            <tr>
                              <th>S.No</th>
                              <th>Building / Block Name</th>
                              <th>No.of Floors</th>
                              <th>Built up Area ({Collegetype})</th>
                              <th>Building Image</th>
                              <th>Campus Type</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody style={{ textAlign: "center" }}>
                            {blockdata !== undefined &&
                              blockdata.map((dep, i) => {
                                return (
                                  <>
                                    <tr>
                                      <td>{i + 1}</td>
                                      <td className="text-left">{dep?.build_block_name}</td>
                                      <td>{dep?.no_of_floors||"-"}</td>
                                      <td>{dep?.site_area||"-"}</td>
                                      <td>
                                        {
                                          <button type="button" onClick={() => viewImage(dep?.building_img)} className="btn btn-primary">
                                            <BsEyeFill size={23}></BsEyeFill>
                                          </button>
                                        }
                                      </td>
                                      <td>{dep?.campus_type||"-"}</td>
                                      <td>
                                        <bie.Button
                                          type="button"
                                          className="btn btn-danger  btn-sm   pull-right"
                                          onClick={() => {
                                            DeleteBuildingReport(dep?.sl_no);
                                          }}
                                        >
                                          <BiTrash />
                                        </bie.Button>
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </bie.Row>
                  )}

                  {BuildingReport && BuildingReport?.length > 0 && (
                    <>
                      {/* <div className="inner-herbpage-service-title-sub p-0">
                                                <h1 className="mb-0">Building Area Details Report</h1>
                                            </div> */}

                      <h5 className="mb-3 innerheader-new">
                        <span>Building Area Details Report</span>
                      </h5>

                      <bie.Row className="px-2 pt-3m-0 mx-1 pt-3 ">
                        <div className="table-responsive">
                          <table table className="table table-bordered mt-2 ">
                            <thead className="table-primary">
                              <tr>
                                <th>Instructional Area ({Collegetype}) </th>
                                <th>Administrative Area ({Collegetype}) </th>
                                <th>Amenities Area ({Collegetype}) </th>
                                <th>Access & Circulation Area ({Collegetype}) </th>
                                <th>Total Built-up Area ({Collegetype})</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                              {BuildingReport !== undefined &&
                                BuildingReport.map((data, i) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{data?.instructional_area}</td>
                                        <td>{data?.admin_area}</td>
                                        <td>{data?.amenities_area}</td>
                                        <td>{data?.access_circul_area}</td>
                                        <td>{data?.total_area}</td>
                                      </tr>
                                    </>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </bie.Row>
                    </>
                  )}
                </bie.Row>
              </bie.Container>
            </Form>
          </FormikProvider>
        </div>
      </div>
    </>
  );
}
